import { Box } from '@mui/material';
import { Suspense } from 'react';

import useAuth from 'shared/hooks/useAuth';
import { usePublicPageDetector } from 'shared/hooks/usePublicPageDetector';
import { Header } from 'shared/ui/Header';
import { Navbar } from 'shared/ui/Navbar';
import { Toast } from 'shared/ui/Toast/Toast';

import { AppRouter } from './providers/router';

const App = () => {
  const isPublicPage = usePublicPageDetector();
  const { authenticated, isLoading } = useAuth();

  const isInvited = true;
  const nav = isInvited && authenticated && !isLoading;

  return (
    <Box minHeight="100vh" display="flex">
      <Box flexGrow={1}>
        <Suspense fallback="">
          {!isPublicPage && authenticated && <Header />}
          <Box
            bgcolor="default"
            display="flex"
            sx={{ width: '100vw', maxWidth: '100%' }}
          >
            {!isPublicPage && nav && <Navbar />}
            <Box flex="1 1" minWidth="0">
              {isInvited && <AppRouter />}
            </Box>
          </Box>
        </Suspense>
      </Box>
      <Toast />
    </Box>
  );
};

export default App;
